import { Link } from "react-router-dom";
import { CalendarDays, CalendarClock, ListTodo, PlayCircle, Sun, Timer, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/common";
import { INTERVENTION_STATUS, canTime, fmtTime } from "@/lib/constants";
import { Kpi, Panel, PanelLink } from "./parts";

const AGENDA_MAX = 8;

const AgendaRow = ({ i }) => (
  <li className="flex flex-col gap-3 rounded-xl border border-white/[0.06] bg-white/[0.02] p-3 sm:flex-row sm:items-center" data-testid={`today-intervention-${i.id}`}>
    <div className="flex min-w-0 flex-1 items-start gap-3">
      <span className="font-mono-dt w-14 shrink-0 pt-0.5 text-base font-medium text-cyan-300">{fmtTime(i.scheduled_at) || "—"}</span>
      <div className="min-w-0 flex-1">
        <p className="truncate font-medium text-white">{i.client_name || "Sans client"}</p>
        <p className="truncate text-sm text-slate-400">{i.title || "(sans objet)"}</p>
      </div>
      <Badge value={i.status} map={INTERVENTION_STATUS} />
    </div>
    <div className="grid grid-cols-2 gap-2 sm:flex sm:shrink-0">
      <Button asChild variant="outline" className="h-11 sm:h-9">
        <Link to={`/interventions/${i.id}`} data-testid={`today-open-${i.id}`}>Fiche<ChevronRight className="ml-1 h-4 w-4" /></Link>
      </Button>
      {canTime(i) && (
        <Button asChild className="h-11 sm:h-9">
          <Link to={`/interventions/${i.id}?chrono=1`} data-testid={`today-timer-${i.id}`}><Timer className="mr-1 h-4 w-4" />Chrono</Link>
        </Button>
      )}
    </div>
  </li>
);

export const ActivityZone = ({ c, today }) => (
  <Panel title="Mon activité" icon={CalendarDays} testid="zone-activity" action={<PanelLink to="/calendrier" testid="activity-planning-link">Planning</PanelLink>}>
    <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
      <Kpi to="/interventions?cat=today" label="Aujourd'hui" value={c.today} icon={Sun} testid="kpi-today" />
      <Kpi to="/interventions?cat=in_progress" label="En cours" value={c.in_progress} icon={PlayCircle} testid="kpi-in_progress" />
      <Kpi to="/interventions?cat=upcoming_7" label="7 prochains jours" value={c.upcoming_7} icon={CalendarClock} testid="kpi-upcoming_7" />
      <Kpi to="/interventions?cat=to_plan" label="À planifier" value={c.to_plan} tone="orange" icon={ListTodo} testid="kpi-to_plan" />
    </div>
    <div className="mt-5" data-testid="dashboard-today-list">
      <h3 className="mb-3 text-xs font-medium uppercase tracking-wider text-slate-400">Agenda du jour</h3>
      {today && !today.length && <p className="rounded-xl border border-dashed border-white/10 p-4 text-sm text-slate-400" data-testid="today-empty">Aucune intervention prévue aujourd'hui</p>}
      <ul className="space-y-2">{(today || []).slice(0, AGENDA_MAX).map((i) => <AgendaRow key={i.id} i={i} />)}</ul>
      {today?.length > AGENDA_MAX && (
        <div className="mt-3"><PanelLink to="/interventions?cat=today" testid="agenda-see-all">Voir les {today.length} interventions du jour</PanelLink></div>
      )}
    </div>
  </Panel>
);
